// removed by extract-text-webpack-plugin
module.exports = {"name":"enKRe","header":"_1aO1x","comment":"abPDY"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerHierarchy/columns.scss
// module id = 786
// module chunks = 0